import { useEffect, type ReactNode } from "react";
import Button from "carbon-react/esm/components/button/__next__";
import Dialog from "carbon-react/esm/components/dialog";

interface ConfirmationDialogProps {
  cancelLabel?: string;
  children: ReactNode;
  confirmLabel: string;
  contentClassName?: string;
  dialogClassName?: string;
  isConfirming?: boolean;
  onCancel(): void;
  onConfirm(): void;
  open: boolean;
  title: string;
}

export function ConfirmationDialog({
  cancelLabel = "Cancel",
  children,
  confirmLabel,
  contentClassName,
  dialogClassName,
  isConfirming = false,
  onCancel,
  onConfirm,
  open,
  title,
}: ConfirmationDialogProps) {
  useEffect(() => {
    if (!open) return;
    window.scrollTo({ behavior: "auto", left: 0, top: 0 });
    window.dispatchEvent(new CustomEvent("loan-management:layout-change"));
  }, [open]);

  return (
    <Dialog
      ariaRole="alertdialog"
      className={dialogClassName}
      onCancel={onCancel}
      open={open}
      restoreFocusOnClose
      showCloseIcon
      size="small"
      title={title}
    >
      <div className={["confirmation-dialog__content", contentClassName].filter(Boolean).join(" ")}>{children}</div>
      <div className="confirmation-dialog__actions">
        <Button disabled={isConfirming} onClick={onCancel} type="button" variant="default">
          {cancelLabel}
        </Button>
        <Button
          disabled={isConfirming}
          onClick={onConfirm}
          type="button"
          variant="default"
          variantType="primary"
        >
          {confirmLabel}
        </Button>
      </div>
    </Dialog>
  );
}